import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import {reducer as formReducer} from 'redux-form';
import {reducer as flashReducer} from 'redux-flash';
import {i18nReducer} from 'react-redux-i18n';
import user from '../../../../core/store/reducers/user';
import layout from './layout';
import workspace from './workspace';
import menu from './menu';
import media from './media';
import contentdefinition from './contentdefinition';
import fielddefinition from './fielddefinition';
import language from './language';
import content from './content';
import block from './block';
import preview from './preview';
import global from './global';


const reducers = combineReducers({
    user: user,
    layout: layout,
    workspace: workspace,
    menu: menu,
    media: media,
    contentdefinition: contentdefinition,
    fielddefinition: fielddefinition,
    language: language,
    content: content,
    block: block,
    form: formReducer,
    flash: flashReducer,
    routing: routerReducer,
    i18n: i18nReducer,
    preview: preview,
    global: global,
});

export default reducers;


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/index.js